import { Card, CardContent } from "@/components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

import { fmtCentsAccounting } from "../format";

/**
 * Net (New Revenue − Churn) single-row card matching the static HTML
 * report's "Total" block. Renders Closed / Forecast / Upside side-by-side
 * with prior-week deltas.
 */
export function TotalRowCard({
  label,
  priorLabel,
  newRevenueClosed,
  newRevenueForecast,
  newRevenueUpside,
  churnClosed,
  churnForecast,
  priorNewRevenueClosed,
  priorNewRevenueForecast,
  priorNewRevenueUpside,
  priorChurnClosed,
  priorChurnForecast,
}: {
  label: string;
  priorLabel: string;
  newRevenueClosed: number;
  newRevenueForecast: number;
  newRevenueUpside: number;
  churnClosed: number;
  churnForecast: number;
  priorNewRevenueClosed?: number | null;
  priorNewRevenueForecast?: number | null;
  priorNewRevenueUpside?: number | null;
  priorChurnClosed?: number | null;
  priorChurnForecast?: number | null;
}) {
  const netClosed = newRevenueClosed - churnClosed;
  const netForecast = newRevenueForecast - churnForecast;
  const netUpside = newRevenueUpside;
  const priorNetClosed =
    priorNewRevenueClosed != null && priorChurnClosed != null
      ? priorNewRevenueClosed - priorChurnClosed
      : null;
  const priorNetForecast =
    priorNewRevenueForecast != null && priorChurnForecast != null
      ? priorNewRevenueForecast - priorChurnForecast
      : null;

  return (
    <Card>
      <CardContent className="pt-4">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>{label}</TableHead>
              <TableHead className="text-right">Closed</TableHead>
              <TableHead className="text-right text-power/70">{priorLabel}</TableHead>
              <TableHead className="text-right">Forecast</TableHead>
              <TableHead className="text-right text-power/70">{priorLabel}</TableHead>
              <TableHead className="text-right">Upside</TableHead>
              <TableHead className="text-right text-power/70">{priorLabel}</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            <TableRow className="bg-power/10">
              <TableCell className="font-semibold">Net</TableCell>
              <TableCell className="text-right font-mono font-semibold">
                {fmtCentsAccounting(netClosed)}
              </TableCell>
              <TableCell className="text-right font-mono text-muted-foreground">
                {priorNetClosed != null ? fmtCentsAccounting(priorNetClosed) : "—"}
              </TableCell>
              <TableCell className="text-right font-mono font-semibold">
                {fmtCentsAccounting(netForecast)}
              </TableCell>
              <TableCell className="text-right font-mono text-muted-foreground">
                {priorNetForecast != null ? fmtCentsAccounting(priorNetForecast) : "—"}
              </TableCell>
              <TableCell className="text-right font-mono font-semibold">
                {fmtCentsAccounting(netUpside)}
              </TableCell>
              <TableCell className="text-right font-mono text-muted-foreground">
                {priorNewRevenueUpside != null
                  ? fmtCentsAccounting(priorNewRevenueUpside)
                  : "—"}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
